export default __webpack_public_path__ + "static/media/Avatar-11.589e7d19.png";